import React from 'react'
import {
  LoaderSwitcher,
  MerchantLoader,
  StripeConnectLoader
} from 'router/Loaders'
import { MerchantIntegrationsLoader } from 'router/Loaders/MerchantIntegrationsLoader'
import { isAdmin, isManager, useSession } from 'packages/@slerp/accounts'
import StaffLayout from 'components/Layout/StaffLayout'
import AdminLayout from 'components/Layout'

export const LayoutWrapper = () => {
  const { user } = useSession()

  const isAdminUser = isAdmin(user)
  const isManagerUser = isManager(user)

  if (isAdminUser) {
    return (
      <MerchantLoader>
        {(isParentLoaded) => (
          <MerchantIntegrationsLoader isParentLoaded={isParentLoaded}>
            {(isParentLoaded) => (
              <StripeConnectLoader isParentLoaded={isParentLoaded}>
                {(isParentLoaded) => (
                  <LoaderSwitcher isParentLoaded={isParentLoaded}>
                    <AdminLayout />
                  </LoaderSwitcher>
                )}
              </StripeConnectLoader>
            )}
          </MerchantIntegrationsLoader>
        )}
      </MerchantLoader>
    )
  }

  if (isManagerUser) {
    return (
      <MerchantLoader>
        {(isParentLoaded) => (
          <MerchantIntegrationsLoader isParentLoaded={isParentLoaded}>
            {(isParentLoaded) => (
              <LoaderSwitcher isParentLoaded={isParentLoaded}>
                <StaffLayout />
              </LoaderSwitcher>
            )}
          </MerchantIntegrationsLoader>
        )}
      </MerchantLoader>
    )
  }

  return (
    <MerchantLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <StaffLayout />
        </LoaderSwitcher>
      )}
    </MerchantLoader>
  )
}
